var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer-root"},[_c('button',{staticClass:"about",attrs:{"title":"how to play"},on:{"click":function($event){return _vm.$emit('about')}}},[_vm._v("?")])])}
var staticRenderFns = []

export { render, staticRenderFns }